<template>
  <Drawer v-model="modal" :title="$t('name.cex.tool.title')" width="350" :mask-style="{backgroundColor: 'rgba(55,55,55,.2)'}">
    <Form ref="form" :model="form" :rules="rule">
      <Row :gutter="20">
        <Col :span="12">
          <FormItem :label="$t('name.cex.tool.c')" prop="c">
            <div style="width: 100%; display: inline-block">
              <InputNumber :max="maxEdge" :min="0" v-model="form.c" style="width: 100%;"/>
            </div>
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem :label="$t('name.cex.tool.k')" prop="k">
            <div style="width: 100%; display: inline-block">
              <InputNumber :max="maxEdge" :min="0" v-model="form.k" style="width: 100%;"/>
            </div>
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem :label="$t('name.cex.tool.g')" prop="g">
            <div style="width: 100%; display: inline-block">
              <InputNumber :max="maxEdge" :min="0" v-model="form.g" style="width: 100%;"/>
            </div>
          </FormItem>
        </Col>
        <Col :span="12">
          <FormItem :label="$t('name.cex.tool.z')" prop="z">
            <div style="width: 100%; display: inline-block">
              <InputNumber :max="maxWeight" :min="0" v-model="form.z" style="width: 100%;"/>
            </div>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <Row :gutter="20">
      <Col :span="12">
        <Button type="primary" :loading="loading" @click="onPost(true)" long>{{ $t('name.cex.button_tool') }}</Button>
      </Col>
      <Col :span="12">
        <Button :loading="loading" @click="onPost(false)" long>{{ $t('name.cex.tool.button') }}</Button>
      </Col>
    </Row>
    <Alert v-if="weight" style="margin-top: 20px;">
      {{ $t('name.cex.tool.weight') }}: {{ this.weight }} <Divider type="vertical" />
      {{ $t('name.cex.tool.volume') }}: {{ this.volume }}
    </Alert>
    <div v-for="(item, index) in bultos" :key="index" class="ivu-alert ivu-alert-info" style="margin-top: 20px;">
      <span class="ivu-alert-message">{{ item.largo }} * {{ item.ancho }} * {{ item.alto }} ≈ {{ item.weight }}Kg</span>
      <a class="ivu-alert-close" @click="onRemove(index)"><i class="ivu-icon ivu-icon-ios-close"></i></a>
    </div>
  </Drawer>
</template>
<script>
import Config from '@/tools/config'

export default {
  props: {
    num: Number,
    kilos: Number,
    cex: Object,
    bultos: Array,
  },
  computed: {
    maxEdge() {
      return parseFloat(Config.get('cex_max_edge'))
    },
    maxWeight() {
      return parseFloat(Config.get('cex_max_weight'))
    }
  },
  data() {
    return {
      modal: false,
      loading: false,
      volume: 0,
      weight: 0,
      form: {
        c: 0,
        k: 0,
        g: 0,
        z: 1
      },
      rule: {
        c: [
          { required: true, type: 'number', message: ' ', trigger: 'blur' }
        ],
        k: [
          { required: true, type: 'number', message: ' ', trigger: 'blur' }
        ],
        g: [
          { required: true, type: 'number', message: ' ', trigger: 'blur' }
        ],
        z: [
          { required: true, type: 'number', message: ' ', trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    open() {
      this.modal = true
    },
    onPost(type) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 先加在一起
          const edge = this.form.c + this.form.k + this.form.g
          // 判断长宽高总和
          if(edge > Config.get('cex_max_count')) {
            return this.$Message.warning(this.$t('message.cex.tool.count') + Config.get('cex_max_count'))
          }

          // 算出体积重量
          this.volume = (this.form.c * this.form.k * this.form.g * this.cex.volume / 1000).toFixed(1);
          
          // 算出最大重量
          this.weight = Math.max(this.volume, this.form.z)
          
          // 判断是否追加
          if(type){
            this.bultos.push({
              largo: this.form.c,
              ancho: this.form.k,
              alto: this.form.g,
              kilos: this.form.z,
              volumen: this.volume,
              weight: this.weight
            })
            this.$emit('update:num', this.num + 1)
            this.$emit('update:kilos', this.kilos + this.weight)
            this.$emit('add')
          }
        }
      })
    },
    onRemove(index) {
      console.log(index, this.bultos)
      const weight = this.bultos[index].weight
      this.bultos.splice(index, 1)
      console.log(this.bultos)
      this.$emit('update:num', this.num - 1)
      this.$emit('update:kilos', this.kilos - weight)
      this.$emit('add')
    }
  }
}
</script>